import React from "react";

const SkeletonLoader = ({ times, loaderClass }) => (
  <React.Fragment>
    {[...Array(times)].map((_, index) => (
      <div key={index} className={`m-t m-l m-r ${loaderClass ? loaderClass : 'skeleton-loader'}`}></div>
    ))}
  </React.Fragment>
);

export default SkeletonLoader;
